export default __webpack_public_path__ + "static/media/marvel-silver.1d43a08b.jpg";